/**
 *  01/06/2020 v 1.0 - JuanMa
 *  05/06/2022 v.1.1  Unión Sidemur y Planifikator
 *  20/05/2022 v.1.2 Añadida funcion transformadorCadenaFechaToCadenaYTimestamp.
 **/

import {
    getFormattedMesAgnoFromNow,
    getFormattedAgnoFromNow,
    getDateFromFormattedString,
    getTimestampFromDate,
    getFormattedDateNow,
    getDateTimeFromFormattedString
} from "./DateUtils";
import {stringWithZerosIzq} from "./StringUtils";

//Formato XX%
export const transformadorPorcentaje= (dato) => {
    if (dato && dato != "") {
        if (dato.includes("%")) {
            let partes = dato.split("%");
            let numero = Number(partes[0].trim()).toString();
            if (isNaN(numero))
                numero = 0;
            return numero;
        } else {
            let numero = Number(dato.trim()).toString();
            if (isNaN(numero))
                numero = 0;
            return numero;
        }
    }
    else {
        return 0;
    }
}

export const transformadorCadenaFecha=  (dato) => {
    let newCadenaFecha= "";

    //Tenemos dia 1 => 01/12/2020
    if ( (dato.length == 1 || dato.length==2)){
        if (!isNaN(dato)) {
            newCadenaFecha= stringWithZerosIzq(dato, 2) + "/" + getFormattedMesAgnoFromNow();
            return getDateFromFormattedString(newCadenaFecha);
        }
    }

    //Tenemos diames 112 => 01/12/2020
    if ( dato.length == 3 && !dato.includes('/')){
        let dia= dato.substring(0,0);
        if (isNaN(dia) || Number(dia) <= 0 || Number(dia) > 31)
            return null;
        let mes= dato.substring(1,2);
        if (isNaN(mes) || Number(mes) <= 0 || Number(mes) > 12)
            return null;
        return getDateFromFormattedString(dia + "/" + mes + "/" + getFormattedAgnoFromNow());
    }

    //Tenemos diames 0112 => 01/12/2020
    if ( dato.length == 4 && !dato.includes('/')){
        let dia= dato.substring(0,2);
        if (isNaN(dia) || Number(dia) <= 0 || Number(dia) > 31)
            return null;
        let mes= dato.substring(2,4);
        if (isNaN(mes) || Number(mes) <= 0 || Number(mes) > 12)
            return null;
        return getDateFromFormattedString(dia + "/" + mes + "/" + getFormattedAgnoFromNow());
    }

    //Tenemos diamesaño 011220 => 01/12/2020
    if ( dato.length == 6 && !dato.includes('/')){
        let dia= dato.substring(0,2);
        if (isNaN(dia) || Number(dia) <= 0 || Number(dia) > 31)
            return null;
        let mes= dato.substring(2,4);
        if (isNaN(mes) || Number(mes) <= 0 || Number(mes) > 12)
            return null;
        let agno= dato.substring(4,6);
        if (isNaN(agno) || Number(agno) <= 0)
            return null;
        agno= Number(agno) + 2000;
        return getDateFromFormattedString(dia + "/" + mes + "/" + agno.toString());
    }

    //tenemos dia/mes 01/12 => 01/12/2020
    if ( dato.length == 5 && dato.includes('/')){
        let partes= dato.split("/");
        if (partes.length != 2)
            return null;
        let dia= partes[0];
        if (isNaN(dia) || Number(dia) <= 0 || Number(dia) > 31)
            return null;
        let mes= partes[1];
        if (isNaN(mes) || Number(mes) <= 0 || Number(mes) > 12)
            return null;
        return getDateFromFormattedString(dia + "/" + mes + "/" + getFormattedAgnoFromNow());
    }

    //tenemos dia/mes/año 01/12/20 => 01/12/2020
    if ( dato.length == 8 && dato.includes('/')){
        let partes= dato.split("/");
        if (partes.length != 3)
            return null;
        let dia= partes[0];
        if (isNaN(dia) || Number(dia) <= 0 || Number(dia) > 31)
            return null;
        let mes= partes[1];
        if (isNaN(mes) || Number(mes) <= 0 || Number(mes) > 12)
            return null;
        let agno= partes[2];
        if (isNaN(agno) || Number(agno) <= 0)
            return null;
        agno= Number(agno) + 2000;
        return getDateFromFormattedString(dia + "/" + mes + "/" + agno.toString());
    }

    //tenemos dia/mes/año 01/12/2020 => 01/12/2020
    if ( dato.length == 10 && dato.includes('/')){
        let partes= dato.split("/");
        if (partes.length != 3)
            return null;
        let dia= partes[0];
        if (isNaN(dia) || Number(dia) <= 0 || Number(dia) > 31)
            return null;
        let mes= partes[1];
        if (isNaN(mes) || Number(mes) <= 0 || Number(mes) > 12)
            return null;
        let agno= partes[2];
        if (isNaN(agno) || Number(agno) <= 0)
            return null;
        return getDateFromFormattedString(dia + "/" + mes + "/" + agno);
    }


    return null;
}


export const transformadorCadenaFechaToCadenaYTimestamp=  (dato) => {
    let newCadenaFecha= "";
    let newTSFecha= null;

    //console.log("XXXXX transformadorCadenaFechaToCadenaYFecha: ", dato);

    //Tenemos dia 1 => 01/12/2020
    if ( (dato.length == 1 || dato.length==2)){
        //console.log("caso 1");
        if (!isNaN(dato)) {
            newCadenaFecha= stringWithZerosIzq(dato, 2) + "/" + getFormattedMesAgnoFromNow();
            newTSFecha= getDateFromFormattedString(newCadenaFecha).getTime();
            return {sFecha: newCadenaFecha, tsFecha: newTSFecha};
        }
    }

    //Tenemos diames 112 => 01/12/2020
    if ( dato.length == 3 && !dato.includes('/')){
        //console.log("caso 2");
        let dia= dato.substring(0,1);
        //console.log("dia: ", dia);
        if (isNaN(dia) || Number(dia) <= 0 || Number(dia) > 31)
            return null;
        let mes= dato.substring(1,3);
        //console.log("mes: ", mes);
        if (isNaN(mes) || Number(mes) <= 0 || Number(mes) > 12)
            return null;
        newCadenaFecha= dia + "/" + mes + "/" + getFormattedAgnoFromNow();
        newTSFecha= getDateFromFormattedString(newCadenaFecha).getTime();
        return {sFecha: newCadenaFecha, tsFecha: newTSFecha};
    }

    //Tenemos diames 0112 => 01/12/2020
    if ( dato.length == 4 && !dato.includes('/')){
        //console.log("caso 3");
        let dia= dato.substring(0,2);
        if (isNaN(dia) || Number(dia) <= 0 || Number(dia) > 31)
            return null;
        let mes= dato.substring(2,4);
        if (isNaN(mes) || Number(mes) <= 0 || Number(mes) > 12)
            return null;
        newCadenaFecha= dia + "/" + mes + "/" + getFormattedAgnoFromNow();
        newTSFecha= getDateFromFormattedString(newCadenaFecha).getTime();
        return {sFecha: newCadenaFecha, tsFecha: newTSFecha};
    }

    //Tenemos diamesaño 011220 => 01/12/2020
    if ( dato.length == 6 && !dato.includes('/')){
        //console.log("caso 5");
        let dia= dato.substring(0,2);
        if (isNaN(dia) || Number(dia) <= 0 || Number(dia) > 31)
            return null;
        let mes= dato.substring(2,4);
        if (isNaN(mes) || Number(mes) <= 0 || Number(mes) > 12)
            return null;
        let agno= dato.substring(4,6);
        if (isNaN(agno) || Number(agno) <= 0)
            return null;
        agno= Number(agno) + 2000;
        newCadenaFecha= dia + "/" + mes + "/" + agno.toString();
        newTSFecha= getDateFromFormattedString(newCadenaFecha).getTime();
        return {sFecha: newCadenaFecha, tsFecha: newTSFecha};
    }

    //tenemos dia/mes 01/12 => 01/12/2020
    if ( dato.length == 5 && dato.includes('/')){
        //console.log("caso 6");
        let partes= dato.split("/");
        if (partes.length != 2)
            return null;
        let dia= partes[0];
        if (isNaN(dia) || Number(dia) <= 0 || Number(dia) > 31)
            return null;
        let mes= partes[1];
        if (isNaN(mes) || Number(mes) <= 0 || Number(mes) > 12)
            return null;
        newCadenaFecha= dia + "/" + mes + "/" + getFormattedAgnoFromNow();
        newTSFecha= getDateFromFormattedString(newCadenaFecha).getTime();
        return {sFecha: newCadenaFecha, tsFecha: newTSFecha};
    }

    //tenemos dia/mes/año 01/12/20 => 01/12/2020
    if ( dato.length == 8 && dato.includes('/')){
        //console.log("caso 7");
        let partes= dato.split("/");
        if (partes.length != 3)
            return null;
        let dia= partes[0];
        if (isNaN(dia) || Number(dia) <= 0 || Number(dia) > 31)
            return null;
        let mes= partes[1];
        if (isNaN(mes) || Number(mes) <= 0 || Number(mes) > 12)
            return null;
        let agno= partes[2];
        if (isNaN(agno) || Number(agno) <= 0)
            return null;
        agno= Number(agno) + 2000;
        newCadenaFecha= dia + "/" + mes + "/" + agno.toString();
        newTSFecha= getDateFromFormattedString(newCadenaFecha).getTime();
        return {sFecha: newCadenaFecha, tsFecha: newTSFecha};
    }

    //tenemos dia/mes/año 01/12/2020 => 01/12/2020
    if ( dato.length == 10 && dato.includes('/')){
        //console.log("caso 8");
        let partes= dato.split("/");
        if (partes.length != 3)
            return null;
        let dia= partes[0];
        //console.log("dia:", dia);
        if (isNaN(dia) || Number(dia) <= 0 || Number(dia) > 31)
            return null;
        let mes= partes[1];
        //console.log("mes:", mes);
        if (isNaN(mes) || Number(mes) <= 0 || Number(mes) > 12)
            return null;
        let agno= partes[2];
        //console.log("agno:", agno);
        if (isNaN(agno) || Number(agno) <= 0)
            return null;
        newCadenaFecha= dia + "/" + mes + "/" + agno;
        newTSFecha= getDateFromFormattedString(newCadenaFecha).getTime();
        return {sFecha: newCadenaFecha, tsFecha: newTSFecha};
    }


    return null;
}


export const transformadorCadenaFechaHoraToCadenaYTimestamp=  (datoFechaHora, conFecha) => {
    let newCadenaFecha= "";
    let newTSFecha= null;

    let partes= datoFechaHora.split(" ");
    let resultadoFecha= "";
    let resultadoHora= "";

    //Calculamos la parte de fecha
    if (partes.length >= 1) {
        let dato= partes[0];

        //Tenemos dia 1 => 01/12/2020
        if ((dato.length == 1 || dato.length == 2)) {
            //console.log("caso 1");
            if (!isNaN(dato)) {
                resultadoFecha = stringWithZerosIzq(dato, 2) + "/" + getFormattedMesAgnoFromNow();
            }
        }

        //Tenemos diames 112 => 01/12/2020
        if (dato.length == 3 && !dato.includes('/')) {
            //console.log("caso 2");
            let dia = dato.substring(0, 1);
            //console.log("dia: ", dia);
            if (isNaN(dia) || Number(dia) <= 0 || Number(dia) > 31)
                return null;
            let mes = dato.substring(1, 3);
            //console.log("mes: ", mes);
            if (isNaN(mes) || Number(mes) <= 0 || Number(mes) > 12)
                return null;
            resultadoFecha = dia + "/" + mes + "/" + getFormattedAgnoFromNow();
        }

        //Tenemos diames 0112 => 01/12/2020
        if (dato.length == 4 && !dato.includes('/')) {
            //console.log("caso 3");
            let dia = dato.substring(0, 2);
            if (isNaN(dia) || Number(dia) <= 0 || Number(dia) > 31)
                return null;
            let mes = dato.substring(2, 4);
            if (isNaN(mes) || Number(mes) <= 0 || Number(mes) > 12)
                return null;
            resultadoFecha = dia + "/" + mes + "/" + getFormattedAgnoFromNow();
        }

        //Tenemos diamesaño 011220 => 01/12/2020
        if (dato.length == 6 && !dato.includes('/')) {
            //console.log("caso 5");
            let dia = dato.substring(0, 2);
            if (isNaN(dia) || Number(dia) <= 0 || Number(dia) > 31)
                return null;
            let mes = dato.substring(2, 4);
            if (isNaN(mes) || Number(mes) <= 0 || Number(mes) > 12)
                return null;
            let agno = dato.substring(4, 6);
            if (isNaN(agno) || Number(agno) <= 0)
                return null;
            agno = Number(agno) + 2000;
            resultadoFecha = dia + "/" + mes + "/" + agno.toString();
        }

        //tenemos dia/mes 01/12 => 01/12/2020
        if (dato.length == 5 && dato.includes('/')) {
            //console.log("caso 6");
            let partes = dato.split("/");
            if (partes.length != 2)
                return null;
            let dia = partes[0];
            if (isNaN(dia) || Number(dia) <= 0 || Number(dia) > 31)
                return null;
            let mes = partes[1];
            if (isNaN(mes) || Number(mes) <= 0 || Number(mes) > 12)
                return null;
            resultadoFecha = dia + "/" + mes + "/" + getFormattedAgnoFromNow();
        }

        //tenemos dia/mes/año 01/12/20 => 01/12/2020
        if (dato.length == 8 && dato.includes('/')) {
            //console.log("caso 7");
            let partes = dato.split("/");
            if (partes.length != 3)
                return null;
            let dia = partes[0];
            if (isNaN(dia) || Number(dia) <= 0 || Number(dia) > 31)
                return null;
            let mes = partes[1];
            if (isNaN(mes) || Number(mes) <= 0 || Number(mes) > 12)
                return null;
            let agno = partes[2];
            if (isNaN(agno) || Number(agno) <= 0)
                return null;
            agno = Number(agno) + 2000;
            resultadoFecha = dia + "/" + mes + "/" + agno.toString();
        }

        //tenemos dia/mes/año 01/12/2020 => 01/12/2020
        if (dato.length == 10 && dato.includes('/')) {
            //console.log("caso 8");
            let partes = dato.split("/");
            if (partes.length != 3)
                return null;
            let dia = partes[0];
            //console.log("dia:", dia);
            if (isNaN(dia) || Number(dia) <= 0 || Number(dia) > 31)
                return null;
            let mes = partes[1];
            //console.log("mes:", mes);
            if (isNaN(mes) || Number(mes) <= 0 || Number(mes) > 12)
                return null;
            let agno = partes[2];
            //console.log("agno:", agno);
            if (isNaN(agno) || Number(agno) <= 0)
                return null;
            resultadoFecha = dia + "/" + mes + "/" + agno;
        }
    }

    //Calculamos la parte de hora
    if (partes.length == 2 && Boolean(conFecha)) {
        let dato= partes[0];

        //Tenemos la hora 08 => 08:00:00
        if ((dato.length == 1 || dato.length == 2)) {
            //console.log("caso B1");
            if (!isNaN(dato)) {
                resultadoFecha = stringWithZerosIzq(dato, 2) + ":00:00";
            }
        }

        //Tenemos  0830=> 08:30:00
        if (dato.length == 4 && !dato.includes(':')) {
            //console.log("caso b2");
            let hora = dato.substring(0, 2);
            console.log("hora: ", hora);
            if (isNaN(hora) || Number(hora) < 0 || Number(hora) > 23)
                return null;
            let minutos = dato.substring(2, 4);
            console.log("minutos: ", minutos);
            if (isNaN(minutos) || Number(minutos) < 0 || Number(minutos) > 59)
                return null;
            resultadoHora = hora + ":" + minutos + ":00";
        }

        //Tenemos  083055=> 08:30:55
        if (dato.length == 6 && !dato.includes(':')) {
            //console.log("caso b3");
            let hora = dato.substring(0, 2);
            console.log("hora: ", hora);
            if (isNaN(hora) || Number(hora) < 0 || Number(hora) > 23)
                return null;
            let minutos = dato.substring(2, 4);
            console.log("minutos: ", minutos);
            if (isNaN(minutos) || Number(minutos) < 0 || Number(minutos) > 59)
                return null;

            let segundos = dato.substring(4, 6);
            console.log("segundos: ", segundos);
            if (isNaN(segundos) || Number(segundos) < 0 || Number(segundos) > 59)
                return null;

            resultadoHora = hora + ":" + minutos + ":" + segundos;
        }

    }

    if (resultadoFecha != "" || resultadoHora != ""){
        resultadoFecha= resultadoFecha != "" ? resultadoFecha : getFormattedDateNow();
        resultadoHora= resultadoHora != "" ? resultadoHora : "00:00:00";

        let newCadenaFechaHora= resultadoFecha + " " + resultadoHora;
        newTSFecha= getDateTimeFromFormattedString(newCadenaFechaHora).getTime();
        return {sFecha: newCadenaFecha, tsFecha: newTSFecha};
    }
    else{
        return null;
    }

}




/*
export const transformadorCadenaFecha=  (dato) => {
    console.log("TransformadorCadenaFecha");
    console.log("inicial -> " + dato);

    let newCadenaFecha= "";
    //Sólo se pone el dia: añadimos el mes actual y el año
    if ( (dato.length == 1 || dato.length==2)){
        console.log("caso 1");
        if (!isNaN(dato)) {
            newCadenaFecha= stringWithZerosIzq(dato, 2) + "/" + getFormattedMesAgnoFromNow();
            return newCadenaFecha;
        }
    }

    //Tenemos diames 112 => 01/12/2020
    if ( dato.length == 3 && !dato.includes('/')){
        console.log("caso 2");
        let dia= dato.substring(0,0);
        if (isNaN(dia) || Number(dia) <= 0 || Number(dia) > 31){
            return "ERROR";
        }
        let mes= dato.substring(1,2);
        if (isNaN(mes) || Number(mes) <= 0 || Number(mes) > 12){
            return "ERROR";
        }
        return dia + "/" + mes + "/" + getFormattedAgnoFromNow();
    }

    //Tenemos diames 0112 => 01/12/2020
    if ( dato.length == 4 && !dato.includes('/')){
        console.log("caso 3");
        let dia= dato.substring(0,2);
        if (isNaN(dia) || Number(dia) <= 0 || Number(dia) > 31){
            return "ERROR";
        }
        let mes= dato.substring(2,4);
        if (isNaN(mes) || Number(mes) <= 0 || Number(mes) > 12){
            return "ERROR";
        }
        return dia + "/" + mes + "/" + getFormattedAgnoFromNow();
    }

    //Tenemos diamesaño 011220 => 01/12/2020
    if ( dato.length == 6 && !dato.includes('/')){
        //console.log("caso 4");
        let dia= dato.substring(0,2);
        if (isNaN(dia) || Number(dia) <= 0 || Number(dia) > 31){
            return "ERROR";
        }
        let mes= dato.substring(2,4);
        if (isNaN(mes) || Number(mes) <= 0 || Number(mes) > 12){
            return "ERROR";
        }
        let agno= dato.substring(4,6);
        if (isNaN(agno) || Number(agno) <= 0){
            return "ERROR";
        }
        agno= Number(agno) + 2000;
        return dia + "/" + mes + "/" + agno.toString();
    }

    //tenemos dia/mes 01/12 => 01/12/2020
    if ( dato.length == 5 && dato.includes('/')){
        console.log("caso 5");
        let partes= dato.split("/");
        if (partes.length != 2)
            return "ERROR";
        let dia= partes[0];
        if (isNaN(dia) || Number(dia) <= 0 || Number(dia) > 31){
            return "ERROR";
        }
        let mes= partes[1];
        if (isNaN(mes) || Number(mes) <= 0 || Number(mes) > 12){
            return "ERROR";
        }
        return dia + "/" + mes + "/" + getFormattedAgnoFromNow();
    }

    //tenemos dia/mes 01/12/20 => 01/12/2020
    if ( dato.length == 8 && dato.includes('/')){
        console.log("caso 6");
        let partes= dato.split("/");
        if (partes.length != 3)
            return "ERROR";
        let dia= partes[0];
        if (isNaN(dia) || Number(dia) <= 0 || Number(dia) > 31){
            return "ERROR";
        }
        let mes= partes[1];
        if (isNaN(mes) || Number(mes) <= 0 || Number(mes) > 12){
            return "ERROR";
        }

        let agno= partes[2];
        if (isNaN(agno) || Number(agno) <= 0){
            return "ERROR";
        }
        agno= Number(agno) + 2000;
        return dia + "/" + mes + "/" + agno.toString();
    }


}
*/

export const pruebasTransformadorCadenaFecha= () => {
    console.log("PROBANDO VALIDADOR DE CADENA");
    let resultadoCorrecto= "02/06/2020";

    let origen= "2";
    let result= transformadorCadenaFecha(origen);
    console.log (origen, " =>", result, " ? ", result === resultadoCorrecto ? " OK! " : " ERROR!");

    origen= "02";
    result= transformadorCadenaFecha(origen);
    console.log (origen, " =>", result, " ? ", result === resultadoCorrecto ? " OK! " : " ERROR!");

    origen= "0206";
    result= transformadorCadenaFecha(origen);
    console.log (origen, " =>", result, " ? ", result === resultadoCorrecto ? " OK! " : " ERROR!");

    origen= "02/06";
    result= transformadorCadenaFecha(origen);
    console.log (origen, " =>", result, " ? ", result === resultadoCorrecto ? " OK! " : " ERROR!");

    origen= "020620";
    result= transformadorCadenaFecha(origen);
    console.log (origen, " =>", result, " ? ", result === resultadoCorrecto ? " OK! " : " ERROR!");

    origen= "02/06/20";
    result= transformadorCadenaFecha(origen);
    console.log (origen, " =>", result, " ? ", result === resultadoCorrecto ? " OK! " : " ERROR!");

    origen= "02/06/2020";
    result= transformadorCadenaFecha(origen);
    console.log (origen, " =>", result, " ? ", result === resultadoCorrecto ? " OK! " : " ERROR!");


}
